import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class SumExpression extends ExpressionRule {
    readonly __type: string = "Sum";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();
        let dd = new NumberDataDefinition();
        dd.list = true;

        this.value1 = ExpressionValue.createExpressionValue(this, "sumValue", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let value = this.value1.evaluate(data, testContext);
        return value.reduce((a: number, b: number) => a + b, 0);
    }
}
